import { render, staticRenderFns } from "./upUnit.vue?vue&type=template&id=47197215&scoped=true&"
import script from "./upUnit.vue?vue&type=script&lang=js&"
export * from "./upUnit.vue?vue&type=script&lang=js&"
import style0 from "./upUnit.vue?vue&type=style&index=0&id=47197215&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47197215",
  null
  
)

export default component.exports